/* eslint-disable */
import React, { useState, useEffect } from 'react'; // eslint-disable-next-line
import './events.css';
import { useLocation, useParams, Link } from 'react-router-dom';
import { general, config } from '../config/config';
import { copiriPortalRequest, getLanguagePackUrl } from '../api/api';
import Loader from '../common/Loader';
// eslint-disable-next-line
const EventDetails = (props) => {
	const [pageLanguageContent, setPageLanguageContent] = useState([]); // eslint-disable-next-line
	const [commonLangugaeContent, setCommonLangugaeContent] = useState([]); // eslint-disable-next-line
	const [eventDetailedData, setEventDetailedData] = useState([]);
	const [loading, setLoading] = useState(false);
	const location = useLocation();
	const { id, type } = useParams();
	useEffect(() => {
		/*document.addEventListener(
			'keydown',
			function () {
				if (event.keyCode == 123) {
					return false;
				} else if (event.ctrlKey && event.shiftKey && event.keyCode == 73) {
					return false;
				} else if (event.ctrlKey && event.keyCode == 85) {
					return false;
				}
			},
			false,
		);

		if (document.addEventListener) {
			document.addEventListener(
				'contextmenu',
				function (e) {
					e.preventDefault();
				},
				false,
			);
		} else {
			document.attachEvent('oncontextmenu', function () {
				window.event.returnValue = false;
			});
		}*/
		getLanguagePack();
		getEventDetails(id);
		window.scrollTo({ top: 0, left: 0, behavior: 'smooth' }); // 'smooth' for animated scroll, 'auto' for instant
		// eslint-disable-next-line
	}, [location.pathname]); // Trigger scroll when pathname changes

	function getEventDetails(id) {
		setLoading(true);
		setEventDetailedData([]);
		copiriPortalRequest('/web/wcrmgl/details/' + id, config.app_version, 'get')
			.then((response) => {
				setLoading(false);
				if (response.data) {
					setEventDetailedData(response?.data);
				}
			})
			.catch((error) => {
				setLoading(false);
			});
	}

	/* function to get the translated language text */
	function getLanguagePack() {
		let checkData = JSON.parse(localStorage.getItem('idiom'));
		if (checkData === null || checkData === undefined || checkData === '') {
			// if not store in local storage, call api to get it and store in local storage
			var getLanguageURL = getLanguagePackUrl();
			copiriPortalRequest(getLanguageURL, config.app_version, 'get')
				.then((response) => {
					if (response?.data?.WCS?.AAA) {
						setCommonLangugaeContent(response.data.WCS.AAA);
					}
					if (response?.data?.WCS?.FTR) {
						setPageLanguageContent(response.data.WCS.FTR);
						localStorage.setItem('idiom', JSON.stringify(response.data.WCS));
					}
				})
				.catch((error) => {});
		} else {
			// if stores in localstorage
			if (checkData?.FTR) {
				setPageLanguageContent(checkData?.FTR);
			}
			if (checkData?.AAA) {
				setCommonLangugaeContent(checkData.AAA);
			}
		}
	}

	return (
		<>
			<div className='section-banner sbg-2 ptb-100'>
				<div className='container'>
					<div className='row'>
						<div className='col-lg-12'>
							<div className='banner-content'>
								<h2>{pageLanguageContent['FTR008'] ? pageLanguageContent['FTR008'] : ''}</h2>
								<nav aria-label='breadcrumb'>
									<ol className='breadcrumb'>
										<li className='breadcrumb-item'>
											<Link to={'/'}>{commonLangugaeContent['AAA001'] ? commonLangugaeContent['AAA001'] : ''}</Link>
											<span className='showSlash'>/</span>
											<Link to={`/${type}`}>
												<span> {type} </span>
											</Link>
										</li>
										<li className='breadcrumb-item active' aria-current='page'>
											{pageLanguageContent['FTR009'] ? pageLanguageContent['FTR009'] : ''}
										</li>
									</ol>
								</nav>
							</div>
						</div>
					</div>
				</div>
			</div>
			{loading ? (
				<Loader />
			) : (
				<div className='portfolio-details ptb-100 user_select_none'>
					<div className='container'>
						<div className='row align-items-top'>
							<div className='col-lg-4 col-sm-4 futureEvents'>
								<div className='project-wrap hover-container'>
									<div className='project-video-wrap'>
										{eventDetailedData.logo ? (
											<img
												src={'../../assets/img/pages/' + eventDetailedData?.logo + '.webp'}
												alt={eventDetailedData?.logo}
												className='trasnition '
											/>
										) : (
											<img src={general?.dark_logo} alt={general?.dark_logo} className='trasnition ' />
										)}
										{/*<img src={eventDetailedData?.logo} alt='blog-4' className='project-video' />*/}
										<span className='tooltip-content'>{eventDetailedData?.numeral}</span>
									</div>
								</div>
								<div className='portfolio-content'>
									<div className='sub-title'>{eventDetailedData?.numeral}</div>
									<ul>
										<li>
											{' '}
											<span className='title'>
												{pageLanguageContent['FTR004'] ? pageLanguageContent['FTR004'] : ''}
											</span>
											<br /> <span>{eventDetailedData?.date}</span>
										</li>
										<li>
											{' '}
											<span className='title'>
												{pageLanguageContent['FTR005'] ? pageLanguageContent['FTR005'] : ''}
											</span>{' '}
											<br />
											<span>{eventDetailedData?.host}</span>
										</li>
										<li>
											{' '}
											<span className='title'>
												{pageLanguageContent['FTR006'] ? pageLanguageContent['FTR006'] : ''}
											</span>{' '}
											<br />
											<span>{eventDetailedData?.location}</span>
										</li>
										{eventDetailedData?.website && (
											<li>
												<span className='title'>
													{pageLanguageContent['FTR007'] ? pageLanguageContent['FTR007'] : ''}
												</span>{' '}
												<br />
												<Link to={eventDetailedData?.website} target='_blank' className={`nav-link`}>
													<span>{eventDetailedData?.website}</span>
												</Link>
											</li>
										)}
									</ul>
								</div>
							</div>

							<div className='col-lg-8 col-sm-8'>
								<div className='project-dec'>
									{
										eventDetailedData.content &&
										<p
											dangerouslySetInnerHTML={{ __html: eventDetailedData?.content.replace(/\<br>/g, '<br><br>') }}
											style={{ color: '#fff', whiteSpace: 'pre-line' }}
										></p>
									}
									{/*<div className='project-image-waper'>
									<div className='row'>
										<div className='col-xl-6 col-md-6'>
											<div className='image'>
												<a href='assets/img/all-img/blog-4.jpg' className='popup-btn'>
													<img src={general?.logo} alt='blog-4' />
												</a>
											</div>
										</div>
										<div className='col-xl-6 col-md-6'>
											<div className='image'>
												<a href='assets/img/all-img/blog-5.jpg' className='popup-btn'>
													<img src={general?.logo} alt='blog-5' />
												</a>
											</div>
										</div>
									</div>
								</div>*/}
								</div>
							</div>
						</div>
					</div>
				</div>
			)}
		</>
	);
};

export default EventDetails;
